import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
// import blue from "@material-ui/core/colors/blue";
// import inidgo from "@material-ui/core/colors/indigo";
import "./style.scss";
import { create } from "jss";
import rtl from "jss-rtl";
import { StylesProvider, jssPreset } from "@material-ui/core/styles";

// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#b945f7",
      contrastText: "#FFFFFF",
      dark: "#b945f7",
      light: "#b945f7",
    },
    secondary: {
      main: "#b945f7",
      contrastText: "#FFFFFF",
      dark: "#b945f7",
      light: "#b945f7",
    },
  },
  direction: "rtl",
  typography: {
    fontFamily: `vazir , sans-serif`,
  },
});

ReactDOM.render(
  <React.Fragment>
    <ThemeProvider theme={theme}>
      <StylesProvider jss={jss}>
        <App />
      </StylesProvider>
    </ThemeProvider>
  </React.Fragment>,
  document.getElementById("root")
);
